import { DataTable } from '@/components/ui/data-table'
import { StatusBadge } from '@/components/ui/status-badge'
import type { AccountDetailResponse, AccountDomain } from '@/lib/types'

interface DomainsTabProps {
  account: AccountDetailResponse
}

export function DomainsTab({ account }: DomainsTabProps): React.JSX.Element {
  const columns = [
    {
      key: 'domain',
      label: 'Domain',
      render: (row: AccountDomain) => <span className="font-medium">{row.domain}</span>,
    },
    {
      key: 'status',
      label: 'Status',
      render: (row: AccountDomain) => <StatusBadge status={row.status} />,
    },
    {
      key: 'spf',
      label: 'SPF',
      render: (row: AccountDomain) => <DnsCheck ok={row.spf} />,
    },
    {
      key: 'dkim',
      label: 'DKIM',
      render: (row: AccountDomain) => <DnsCheck ok={row.dkim} />,
    },
    {
      key: 'mx',
      label: 'MX',
      render: (row: AccountDomain) => <DnsCheck ok={row.mx} />,
    },
    {
      key: 'dmarc',
      label: 'DMARC',
      render: (row: AccountDomain) => <DnsCheck ok={row.dmarc} />,
    },
    {
      key: 'created_at',
      label: 'Created',
      render: (row: AccountDomain) => new Date(row.created_at).toLocaleDateString(),
    },
  ]

  return (
    <DataTable
      columns={columns}
      data={account.domains}
      emptyMessage="No domains configured for this account."
    />
  )
}

function DnsCheck({ ok }: { ok: boolean }): React.JSX.Element {
  return (
    <span className={ok ? 'text-green-600 font-medium' : 'text-text-tertiary'}>
      {ok ? 'Pass' : '-'}
    </span>
  )
}
